<mat-dialog-actions class="dialog-correction dialog">
  <div class="close" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </div>

  <div class="content">
    @if (templateRef) {
      <ng-container [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{ data: data }"></ng-container>
    }
  </div>
</mat-dialog-actions>
